// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"d98e0bf2","339":"77fdd663","571":"a7eececf","596":"8742454c","675":"bda23d4e","820":"b7a445b1"}[chunkId] + ".chunk.js";
};